"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authStatusCode = void 0;
exports.authStatusCode = new Map([
    ["auth/too-many-requests", { localeKey: "auth_tooManyRequests" }],
    ["auth/captcha-check-failed", { localeKey: "auth_captchaCheckFailed" }],
    ["auth/invalid-phone-number", { localeKey: "auth_invalidPphoneNumber" }],
    ["auth/quota-exceeded", { localeKey: "auth_quotaExceeded" }],
    ["auth/user-disabled", { localeKey: "auth_userDisabled" }],
    ["auth/invalid-verification-code", { localeKey: "auth_invalidVerificationCode" }],
    ["auth/unknown", { localeKey: "auth_unknown" }],
    ["auth/expired-action-code", { localeKey: "auth_expiredActionCode" }],
    ["auth/merge", { localeKey: "auth_merge" }],
    ["auth/session-expired", { localeKey: "auth_sessionExpired" }],
    ["auth/code-expired", { localeKey: "auth_codeExpired" }],
    ["auth/internal-error", { localeKey: "auth_internalError" }],
    ["auth/missing-phone-number", { localeKey: "auth_missingPhoneNumber" }],
]);
//# sourceMappingURL=authCodeStatus.js.map